var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFi4701537({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_30436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6463 16.8734C5.93891 17.5895 7.42355 18 9.00435 18C13.9738 18 18 13.9651 18 8.9956C18 4.02618 13.9738 0 9.00435 0C4.03494 0 0 4.02618 0 8.9956C0 10.5939 0.419244 12.0786 1.1441 13.3799L0 18L4.6463 16.8734ZM5.14413 5.02181C5.35369 4.82092 5.65942 4.74233 5.93891 4.8035L6.22706 4.86463C6.51529 4.92572 6.75111 5.1179 6.86466 5.37988L7.4323 6.63755C7.57206 6.9432 7.51968 7.31002 7.29257 7.5633L6.94321 7.97379C6.8297 8.10477 6.80352 8.30562 6.89083 8.46288C7.92138 10.3144 9.27508 10.917 9.87768 11.1004C10.0524 11.1615 10.2533 11.083 10.3493 10.9257L10.6026 10.5327C10.8472 10.1572 11.3275 10.0262 11.8602 10.2882L12.9083 10.8122C13.31 11.0043 13.4934 11.4759 13.345 11.8952C12.8122 13.441 11.4498 13.2489 11.4498 13.2489C8.42796 13.1702 6.06112 10.3842 5.03932 8.95197C4.5677 8.27945 4.2795 7.46724 4.36681 6.63754C4.45419 5.81655 4.83848 5.3013 5.14413 5.02181Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_30436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi4701537);
export default __webpack_public_path__ + "static/media/fi_4701537.3233818e90f1fc5539b13988444f989d.svg";
export { ForwardRef as ReactComponent };